import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import attachPreparationItemDialog from '../dialog.savePreparationItemConfirmDialog/attachPreparationItemDialog';
import editPreparationItemCommentDialog from '../dialog.editPreparationItemCommentDialog';
import editPreparationItemDialog from '../dialog.editPreparationItemDialog';
import controller from './preparation-item.controller';
import directive from './preparation-item.directive';
import preparationItemComment from '../preparationItemComment';
import preparationItemDocument from '../preparationItemDocument';
import preparationItemReport from '../preparationItemReport';


export default angular.module('app.components.advisory.auditTrail.preparationItem', [
  alerts,
  amDataService,
  amSharedModelService,
  attachPreparationItemDialog,
  confirmDialog,
  constants,
  docDataService,
  editPreparationItemCommentDialog,
  editPreparationItemDialog,
  loaderService,
  orgDataService,
  preparationItemComment,
  preparationItemDocument,
  preparationItemReport,
  ssDialogService,
  userService,
])
  .directive('amPreparationItem', directive)
  .controller('PreparationItemController', controller)
  .name;

console.log('app.components.advisory.auditTrail.preparationItem created');
